__turbopack_context__.v({
  "item": "Items-module-scss-module__ICHV7q__item",
  "open": "Items-module-scss-module__ICHV7q__open",
  "rotateArrow": "Items-module-scss-module__ICHV7q__rotateArrow",
});
